(function ($) {
  $(function () {
    
    // console.log("coooooookies");

    // Check a cookie and value return true or false
    function mriGetCookie(name) {
      // Split cookie string and get all individual name=value pairs in an array
      var cookieArr = document.cookie.split(";");

      // Loop through the array elements
      for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");

        /* Removing whitespace at the beginning of the cookie name
            and compare it with the given string */
        if (name == cookiePair[0].trim()) {
          // Decode the cookie value and return
          return decodeURIComponent(cookiePair[1]);
        }
      }

      // Return null if not found
      return null;
    }

    // Check the cookie for the Site Banner
    function checkSiteBannerCookie() {
      // If the GDPR cookie is set as closed, hide the cookie notice
      if (mriGetCookie("header-banner") == "closed") {
        $(".header-banner").hide();
      } else {
        // If the cookie is not set, show the Site Banner
        $(".header-banner").removeClass("d-none");
      }
    }

    // Set a session cookie when the site banner is closed
    $("button.banner-close").click(function (e) {
        e.preventDefault();
    let cookieExpires = null;
      document.cookie = "header-banner=closed;path=/;" + cookieExpires;
      $(".header-banner").hide();
    });

    $(document).ready(function () {
      // Check the site banner cookie
      checkSiteBannerCookie();
    });
  });
})($);
